module.exports = __webpack_public_path__ + "static/media/Terms_en.079ec5dd.md";